import React, { useMemo } from 'react'
import Image from 'next/image'
import { Icon } from 'semantic-ui-react'

import { Rating } from 'components/Common'
import OutOfNetwork from 'components/Icons/provider/OutOfNetwork'
import Images from 'images'

import { mergeStyles } from '@enlyt/base'

import { defaultStyles } from './styles'

export const ProviderInfo = ({
  avatar,
  name,
  specialization,
  rating,
  isInNetwork,
  style
}) => {
  const styles = useMemo(() => {
    return mergeStyles(defaultStyles, style)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- defaultStyles is module-level
  }, [defaultStyles, style])

  return (
    <div style={styles.container}>
      {avatar && (
        <div style={styles.imageContainer}>
          <Image
            src={Images[avatar]}
            alt={name ? `${name} profile photo` : 'Provider profile photo'}
            style={{ ...styles.image, maxWidth: '100%', height: 'auto' }}
            width={200}
            height={200}
            unoptimized
          />
          {name === 'Seth Draper' && (
            <div style={styles.absolutVideoStatusContainer}>
              <p style={styles.videoStatusText}>Virtual</p>
              <Icon name={'video camera'} style={styles.videoCameraIcon} />
            </div>
          )}
        </div>
      )}
      <div>
        <div style={styles.nameContainer}>
          <div style={styles.name}>{name}</div>
          {!avatar && name === 'Seth Draper' && (
            <div style={styles.relativeVideoStatusContainer}>
              <p style={styles.videoStatusText}>Virtual</p>
              <Icon name={'video camera'} style={styles.videoCameraIcon} />
            </div>
          )}
        </div>
        <div style={styles.secondary}>{specialization}</div>
        <Rating max={5} value={rating} style={styles.rating} />
        <div style={styles.networkInfoContainer}>
          <div style={styles.networkInfoIconContainer}>
            {!isInNetwork && <OutOfNetwork />}
          </div>
          <span style={styles.networkInfoText}>
            {isInNetwork ? 'Enlyt Health Network' : 'Out of Network'}
          </span>
        </div>
      </div>
    </div>
  )
}
